import { Grid, Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import "./style.css";
import { EightWingsStatus, EightWingsStatusArray, EightWingsTabs } from "../../../../../Enums/EightWingsTabEnum";
import { SourceEightWings } from "../../Constant/Source";
import { useStyles } from "../../RequestOrderList/styles";
import DataGrid from "./DataGrid";
import { useAppDataProvider } from "../../../../../dataprovider";
import { ExcelExport } from "../../../../../Helper/ExportExcel";
import { GetServiceableStatus } from "../../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus } from "../../../../../Enums/UnserviceableStatus";
import { OpenExcelHeader, PlannedToDeliveryExcelHeader, WaitingTTVerifyExcelHeader } from "./Excel";
import PoolList from "../../../../../Components/PoolListComponent/PoolListComponent";

export const EightWingsList = props => {
  const [activeTab, setActiveTab] = React.useState(EightWingsStatus.InProgress);
  const [tabs, setTabs] = React.useState<any[]>([...EightWingsTabs]);
  const classes = useStyles();
  var dataProvider = useAppDataProvider();
  React.useEffect(() => {
    getTabs();
  }, []);
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const ExportToExcel = async (records, fetchRelatedRecords) => {
    switch (activeTab) {
      case EightWingsStatus.Open:
        ExportToExcelForOpen(records, fetchRelatedRecords);
        break;
      case EightWingsStatus.InProgress:
        ExportToExcelForInProgress(records, fetchRelatedRecords);
        break;
      case EightWingsStatus.PlannedToDelivery:
        ExportToExcelForPlannedToDelivery(records, fetchRelatedRecords);
        break;
      case EightWingsStatus.WaitingTTVerify:
        ExportToExcelForWaitingTTVerify(records, fetchRelatedRecords);
        break;
    }
  };
  const ExportToExcelForOpen = (records, fetchRelatedRecords) => {
    ExcelExport(
      OpenExcelHeader,
      records.map(value => [
        value.request.refNo,
        value.request.customerPo,
        value.request.customerCode,
        value.request.requirementCategoryText,
        value.request.pn,
        value.request.isPool,
        value.request.airportCode,
        value.request.acRegistration,
        value.request.createdDate,
        value.request.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : value.request.requestedDeliveryDate == new Date("01/01/9999")
            ? "Exclude"
            : value.request.requestedDeliveryDate,
      ]),
      "Eight Wings List"
    );
  };
  const ExportToExcelForInProgress = (records, fetchRelatedRecords) => {
    ExcelExport(
      PlannedToDeliveryExcelHeader,
      records.map(value => [
        value.request.refNo,
        value.request.customerPo,
        value.request.customerCode,
        value.request.requirementCategoryText,
        value.request.pn,
        value.request.isPool,
        value.request.airportCode,
        value.request.acRegistration,
        value.request.createdDate,
        value.request.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : value.request.requestedDeliveryDate == new Date("01/01/9999")
            ? "Exclude"
            : value.request.requestedDeliveryDate,
        GetServiceableStatus?.find?.(x => x.Value == value?.serviceable?.status)?.Description ?? "",
        GetUnserviceableStatus?.find?.(x => x.Value == value?.unserviceable?.status)?.Description ?? "",
        EightWingsStatusArray?.find?.(x => x.Value == value.status)?.Description ?? "",
        value.serviceable?.pn,
        value.serviceable?.sn,
      ]),
      "Eight Wings List"
    );
  };
  const ExportToExcelForPlannedToDelivery = (records, fetchRelatedRecords) => {
    ExcelExport(
      PlannedToDeliveryExcelHeader,
      records.map(value => [
        value.request.refNo,
        value.request.customerPo,
        value.request.customerCode,
        value.request.requirementCategoryText,
        value.request.pn,
        value.request.isPool,
        value.request.airportCode,
        value.request.acRegistration,
        value.request.createdDate,
        value.request.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : value.request.requestedDeliveryDate == new Date("01/01/9999")
            ? "Exclude"
            : value.request.requestedDeliveryDate,
        GetServiceableStatus?.find?.(x => x.Value == value?.serviceable?.status)?.Description ?? "",
        GetUnserviceableStatus?.find?.(x => x.Value == value?.unserviceable?.status)?.Description ?? "",
        EightWingsStatusArray?.find?.(x => x.Value == value.status)?.Description ?? "",
        value.serviceable?.pn,
        value.serviceable?.sn,
      ]),
      "Eight Wings List"
    );
  };
  const ExportToExcelForWaitingTTVerify = (records, fetchRelatedRecords) => {
    ExcelExport(
      WaitingTTVerifyExcelHeader,
      records.map(value => [
        value.request.refNo,
        value.request.customerPo,
        value.request.customerCode,
        value.request.requirementCategoryText,
        value.request.pn,
        value.request.isPool,
        value.request.airportCode,
        value.request.acRegistration,
        value.request.createdDate,
        value.request.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : value.request.requestedDeliveryDate == new Date("01/01/9999")
            ? "Exclude"
            : value.request.requestedDeliveryDate,
        GetServiceableStatus?.find?.(x => x.Value == value?.serviceable?.status)?.Description ?? "",
        GetUnserviceableStatus?.find?.(x => x.Value == value?.unserviceable?.status)?.Description ?? "",
        EightWingsStatusArray?.find?.(x => x.Value == value.status)?.Description ?? "",
        value.serviceable?.pn,
        value.serviceable?.sn,
      ]),
      "Eight Wings List"
    );
  };
  const getTabs = () => {
    dataProvider
      .post("eightwings/getallcountgroupbystatus", {})
      .then(result => {
        props?.finalCallBack?.();
        if (result?.data?.success == true) {
          var data = result.data.data;
          var tempTabs: any[] = [];
          for (let i = 0; i < EightWingsTabs.length; i++) {
            const tempTab = EightWingsTabs[i];
            let count = data.find(x => x.status == tempTab.Value)?.count ?? 0;
            if (tempTab.Value == EightWingsStatus.WaitingTTVerify) {
              count = count + (data.find(x => x.status == EightWingsStatus.ServiceableDelivered)?.count ?? 0);
            }
            tempTabs.push({ ...tempTab, ...{ Count: count } });
          }
          setTabs(tempTabs);
        }
      })
      .catch(result => {});
  };
  const ListChild = props => (
    <DataGrid {...props} setActiveTab={setActiveTab} requestStatus={activeTab} reloadTabs={getTabs} />
  );
  return (
    <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.13, overflow: "auto" }}>
      <Tabs
        style={{ width: "100%" }}
        variant={"fullWidth"}
        centered
        value={activeTab}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs.map((tab: any) => {
          return <Tab key={tab.Value + "tab"} label={`${tab.Description} (${tab.Count ?? 0})`} value={tab.Value} />;
        })}
      </Tabs>
      <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.15, overflow: "auto" }}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <PoolList
              {...props}
              id="pbh-request-list"
              emptyWhileLoading={true}
              resource={SourceEightWings}
              basePath={SourceEightWings}
              className={classes.list}
              title={"Eight Wings Request Order List"}
              filterDefaultValues={{ status__eq: EightWingsStatus.Open }}
              sort={{ field: "id", order: "DESC" }}
              exporter={ExportToExcel}
            >
              <ListChild />
            </PoolList>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
export default EightWingsList;
